import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { AiPart } from "@intelligems/ig-types/schemas/ai/ui-message-part";
import { PickType } from "@intelligems/ig-types/utils";
import {
  Reasoning as AiElementsReasoning,
  ReasoningContent,
  ReasoningTrigger,
} from "@src/components/ai-elements/reasoning";
import { ReasoningMarkdown } from "./ReasoningMarkdown";
import { Text } from "./Text";
import { WithDebugMessages } from "./WithDebugMessages";
import { getReasoningTexts } from "../part-processor";
import {
  FlattenedPart,
  MessageFlags,
} from "@src/features/ai/components/WorkflowEditor/execution/types";

type ReasoningProps = {
  item: FlattenedPart;
  isStreaming?: boolean;
  part: PickType<AiPart, "reasoning">;
  isCondition: boolean;
} & MessageFlags;

export const Reasoning: React.FC<ReasoningProps> = (props: ReasoningProps) => {
  const { part, item, isCondition, ...rest } = props;

  if (part.text.includes("noop")) {
    return null;
  }

  if (
    !rest.showConditionNodes &&
    part.text === "Workflow execution completed"
  ) {
    return (
      <WithDebugMessages item={item} part={part} debug={props.debug}>
        <Text text={"Finished!"} />
      </WithDebugMessages>
    );
  }

  const { headerText, bodyText } = getReasoningTexts(part, isCondition);

  if (!rest.debug && isCondition && !rest.showConditionNodes) {
    return null;
  }

  return (
    <WithDebugMessages item={item} part={part} debug={props.debug}>
      {rest.showExpandedReasoningMessages ? (
        <div className="mb-4 w-full">
          <IgTypography
            color={"text.secondary"}
            fontWeight={600}
            variant={"body2"}
          >
            {headerText}
          </IgTypography>
          <ReasoningMarkdown
            text={bodyText}
            disableResponseWordByWordLoading={
              rest.disableResponseWordByWordLoading
            }
          />
        </div>
      ) : (
        <AiElementsReasoning className="w-full" isStreaming={props.isStreaming}>
          <ReasoningTrigger title={headerText} />
          <ReasoningContent>{bodyText}</ReasoningContent>
        </AiElementsReasoning>
      )}
    </WithDebugMessages>
  );
};
